import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ServiceAreaService } from '../../../services/service-area.service';
import { CommonModule } from '@angular/common';
import { AutoFocusDirective } from '../../../directives/auto-focus.directive';
import { ReadOnlyIfNoGroupPermissionDirectiveDirective } from '../../../directives/read-only-if-no-group-permission-directive.directive';

@Component({
  selector: 'app-service-area-form',
  templateUrl: './service-area-form.component.html',
  styleUrls: ['./service-area-form.component.scss'],
  imports: [FormsModule, CommonModule, ReactiveFormsModule, RouterModule, AutoFocusDirective, ReadOnlyIfNoGroupPermissionDirectiveDirective],
  standalone: true
})
export class ServiceAreaFormComponent implements OnInit {
  serviceAreaForm!: FormGroup;
  isEditMode = false;
  serviceAreaId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private serviceAreaService: ServiceAreaService
  ) {}

  ngOnInit(): void {
    this.serviceAreaForm = this.fb.group({
      name: ['', Validators.required],
      templateGroupId: [null],
    });

    this.route.paramMap.subscribe((params) => {
      this.serviceAreaId = params.get('id');
      this.isEditMode = !!this.serviceAreaId;

      if (this.isEditMode && this.serviceAreaId) {
        this.loadServiceArea(this.serviceAreaId);
      }
    });
  }

  loadServiceArea(id: string) {  

    this.serviceAreaService.getServiceAreaById(id).subscribe((data: any) => {
      this.serviceAreaForm.patchValue(data);
    });

  }

  saveServiceArea() {
    const serviceAreaData = this.serviceAreaForm.value;

    if (this.isEditMode) {
      this.serviceAreaService.updateServiceArea(this.serviceAreaId!, serviceAreaData).subscribe(() => {
        this.router.navigate(['/service-areas']);
      });      
    } else {
      this.serviceAreaService.addServiceArea(serviceAreaData).subscribe(() => {
        this.router.navigate(['/service-areas'])
      });
    }
  }
  
}
